var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.037 4.62963V13.1852H1V1H16.037V4.62963ZM16.037 4.62963H18.8889M18.8889 4.62963L22 8.25926M18.8889 4.62963V8.25926H22M22 8.25926V12.1481L21.2222 13.1852H18.3704",
    stroke: "#626262",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5556,
    cy: 12.926,
    r: 1.93333,
    stroke: "#626262",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.11117,
    cy: 12.926,
    r: 1.93333,
    stroke: "#626262",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTruck);
export default __webpack_public_path__ + "static/media/boxTruck.fdae91323fd453ad596e5a3a9dfeef26.svg";
export { ForwardRef as ReactComponent };